import Plant from "../../interfaces/control/Plant";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiControl from "../../service/api/ApiControl";
import {PlantFilters} from "../../interfaces/control/PlantFilters";

type PlantsStore = {
  plantDetail: Plant | null;
  data: Plant[];
  error: string | null;
};

const initialState: PlantsStore = {
  plantDetail: null,
  data: [],
  error: null,
};

export const fetchPlants = createAsyncThunk("plants/fetchPlants", async (filters: PlantFilters) => {
  return apiControl.getPlants(filters);
});

export const fetchPlant = createAsyncThunk("plants/fetchPlant", async (id: number) => {
  return apiControl.getPlant(id);
});

const plantsToControlSlice = createSlice({
  name: "plants",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlants.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchPlants.fulfilled, (state, action) => {
        state.data = action.payload;
      })
      .addCase(fetchPlants.rejected, (state, action) => {
        state.error = action.error.message || "An error occurred";
      })
      .addCase(fetchPlant.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchPlant.fulfilled, (state, action) => {
        state.plantDetail = action.payload;
      })
      .addCase(fetchPlant.rejected, (state, action) => {
        state.error = action.error.message || "An error occurred";
      });
  },
});

export default plantsToControlSlice.reducer;
